import { CommonModule } from '@angular/common';
import { Component, Input, ElementRef, inject } from '@angular/core';
import anime from 'animejs';

@Component({
  selector: 'app-toast',
  standalone: true,
  imports: [CommonModule],
  template: `
    <div
      class="px-4 py-2 rounded shadow-md text-white mb-2"
      [ngClass]="{
        'bg-red-400': type === 'error',
        'bg-green-400': type === 'success',
        'bg-blue-400': type === 'info'
      }"
    >
      {{ message }}
    </div>
  `,
})
export class ToastComponent {
  private el = inject(ElementRef);

  @Input() message = '';
  @Input() type: 'success' | 'error' | 'info' = 'info';

  public show(): void {
    anime({
      targets: this.el.nativeElement,
      opacity: [0, 1],
      translateX: ['100%', '0%'],
      easing: 'easeOutExpo',
      duration: 200,
    });
  }

  public hide(): Promise<void> {
    return anime({
      targets: this.el.nativeElement,
      opacity: [1, 0],
      translateX: ['0%', '100%'],
      easing: 'easeInExpo',
      duration: 200,
    }).finished;
  }
}
